import React from 'react';
import styles from './StatCard.module.css';
import { classNames } from '../../utils/helpers';

function StatCard({
  title,
  value,
  subtitle,
  icon,
  trend,
  variant = 'default',
  className,
  ...props
}) {
  return (
    <div className={classNames(styles.card, styles[variant], className)} {...props}>
      <div className={styles.content}>
        <span className={styles.title}>{title}</span>
        <span className={styles.value}>{value}</span>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        {trend && (
          <span className={classNames(styles.trend, styles[`trend-${trend.direction}`])}>
            {trend.direction === 'up' ? '↑' : '↓'} {trend.value}
          </span>
        )}
      </div>
      {icon && (
        <div className={styles.iconWrapper}>
          {icon}
        </div>
      )}
    </div>
  );
}

export default StatCard;
